import React, {Component, Fragment} from 'react';
import {get} from 'lodash';
import ReactHtmlParser from 'react-html-parser';
import GuestOrderInput from '../../../../components/common/Formik/GuestOrderInput';
import NumberFormatInput from '../../../../components/common/Formik/NumberFormatInput';
import isEmpty from "../../../../utils/helpers";
import {trans} from "../../../../utils/helpers";
import DatePicker from 'react-datepicker';
import '../../../../resources/components/ui-component-datepicker.scss'
import { format, parse } from 'date-fns';
import Autosuggest from "react-autosuggest";
import { connect } from 'react-redux';
import { searchSalesAgents } from '../../../../actions/guestOrderActions';
import {createLoadingSelector, selectSuffixOptions} from '../../../../selectors';
import { debounce } from 'lodash';
import {toastr} from "react-redux-toastr";


class CustomerInfoStep extends Component {
	state={
		title:'',
		termsAndCondition:'',
		termsAndConditionsLink:'',
		suggestions: [],
		fieldLabels: {mobileNumber: 'Mobile Phone', company: 'Company',
			businessEmail: 'Business Email', businessNumber: 'Business Phone',
			firstName: 'First Name', lastName: 'Last Name', personalEmail: 'Email', ssn: 'SSN', driverLicense: 'Driver License', salesAgentCP: 'Sales Agent', taxId: "Tax Id", dateOfBirth: "Date of Birth", suffixId: "Suffix"},
		salesAgentSuggestions: [],
		salesAgentValue: '',
	}
	componentDidMount() {
		(async() => {
			const title=await trans('en-us', 'guestOrderScreen.contactInfo.title');
			const termsAndCondition=await trans('en-us', 'guestOrderScreen.contactInfo.termsAndCondition');
			const termsAndConditionsLink=await trans('en-us', 'termsAndConditionsLink');

			this.setState({title,termsAndCondition,termsAndConditionsLink});
			this.props.fetchRequiredOrOptionalFields(this.props.values.accountTypeId)
			this.props.setSubmitting(false)
		})()

		const {setTouched, setFieldValue} = this.props;
		setTouched({});

		this.props.getSystemSuffixes();

	}

	onSalesAgentInputChange = (event, { newValue }) => {
		this.setState({
			salesAgentValue: newValue
		});
		this.props.setFieldValue('account.accountHolder.salesAgentCP', newValue);
	};

	handleSelectSuggestion = (event, { suggestion }) => {
		const salesAgentValue = suggestion.id === '' ? 'No Sales Agent' : `${suggestion.firstName} ${suggestion.lastName}`;
		this.setState({ salesAgentValue });
		this.props.setFieldValue('account.accountHolder.salesAgentCP', salesAgentValue !== 'No Sales Agent' ? suggestion.id : salesAgentValue );
	};

	getSuggestionValue = (suggestion) => {
		return suggestion.id === '' ? 'No Sales Agent' : `${suggestion.firstName} ${suggestion.lastName}`;
	};

	renderSuggestion = (suggestion) => {
		return (
			<div>
				{suggestion.firstName} {suggestion.lastName}
			</div>
		);
	};

	loadSalesAgentSuggestions = debounce(({ value, reason }) => {
		if (reason === 'input-changed' && !isEmpty(value)) {
			this.props.searchSalesAgents(value)
				.then((response) => {
					if (response && response.salesAgents) {
						const salesAgentSuggestions = [
							{ id: '', firstName: 'No', lastName: 'Sales Agent' },
							...response.salesAgents
						];
						this.setState({ salesAgentSuggestions });
					} else {
						this.setState({ salesAgentSuggestions: [{ id: '', firstName: 'No', lastName: 'Sales Agent' }] });
					}
				})
				.catch((error) => {
					toastr.error(error, { position: 'top-center' });
				});
		}
	}, 300);




	dynamicallyRenderFormFields = (field) => {
		let optional = field.required !== true ? "(Optional)" : '';
		const { touched, handleChange, handleBlur, errors, values, setFieldValue, editMode, suffixOptions } = this.props;

		if (field.name === 'salesAgentCP') {
			return (
				<div className="form-group" key={field.index}>
					<label>{this.state.fieldLabels[field.name] + ' ' + optional}</label>
					<div className="input-loader">
						<Autosuggest
							theme={{
								input: {},
								suggestionsContainerOpen: {
									display: "block",
									width: "100%",
									fontSize: "16px",
									backgroundColor: "#fff",
									border: "1px solid #aaa",
									zIndex: 2,
								},
								suggestionsList: {
									margin: 0,
									padding: 0,
									listStyleType: "none",
								},
								suggestion: {
									cursor: "pointer",
									padding: "10px 20px",
								},
								suggestionHighlighted: {
									backgroundColor: "#6ab3c1",
								},
							}}
							suggestions={this.state.salesAgentSuggestions}
							onSuggestionsFetchRequested={this.loadSalesAgentSuggestions}
							onSuggestionsClearRequested={this.clearSalesAgentSuggestions}
							onSuggestionSelected={this.handleSelectSuggestion}
							getSuggestionValue={this.getSuggestionValue}
							renderSuggestion={this.renderSuggestion}
							inputProps={{
								className: get(errors, `account.accountHolder.${field.name}`) && get(touched, `account.accountHolder.${field.name}`)
									? 'form-control is-invalid d-block'
									: 'form-control d-block',
								placeholder: 'Type a sales agent name',
								value: this.state.salesAgentValue,
								onChange: this.onSalesAgentInputChange,
								onBlur: (e) => {
									handleBlur(e);
									this.props.setFieldTouched(`account.accountHolder.${field.name}`, true);
								},
								disabled: editMode
							}}
						/>
						{this.props.salesAgentsLoading && (
							<div className="input-loader-container">
								<span className="input-loader-dot" />
								<span className="input-loader-dot" />
								<span className="input-loader-dot" />
							</div>
						)}
					</div>
					{get(errors, `account.accountHolder.${field.name}`) &&
						get(touched, `account.accountHolder.${field.name}`) && (
							<div className="invalid-feedback">
								{get(errors, `account.accountHolder.${field.name}`)}
							</div>
						)}
				</div>
			);
		} else if (field.name === 'suffixId') {
			return (
				<div className="form-group" key={field.index}>
					<label>{this.state.fieldLabels[field.name] + ' ' + optional}</label>
					<select
						name={`account.accountHolder.${field.name}`}
						value={values.account.accountHolder[field.name] || null}
						onChange={(e) => {
							const selectedValue = parseInt(e.target.value)
							handleChange({
								target: {
									name: `account.accountHolder.${field.name}`,
									value: selectedValue
								}
							});


						}}
						onBlur={handleBlur}
						disabled={editMode}
						className={get(errors, `account.accountHolder.${field.name}`) && get(touched, `account.accountHolder.${field.name}`) ? 'form-control is-invalid' : 'form-control'}
					>
						{/*<option value={null}>Select Suffix</option>*/}
						<option value={null}>Not
							Applicable
						</option>
						{suffixOptions && suffixOptions.map((option) => (
							<option key={option.id} value={option.id}>{option.abbreviation}</option>
						))}
					</select>

					{get(errors, `account.accountHolder.${field.name}`) && get(touched, `account.accountHolder.${field.name}`) &&
						<div className="invalid-feedback">{get(errors, `account.accountHolder.${field.name}`)}</div>}
				</div>
			);
		} else if (['ssn', 'taxId', 'driverLicense'].includes(field.name)) {
			return (
				<div className="form-group" key={field.index}>
					<label>{this.state.fieldLabels[field.name] + ' ' + optional}</label>
					<input
						type="text"
						name={`account.accountHolder.${field.name}`}
						value={values.account.accountHolder[field.name] || ''}
						onChange={(e) => setFieldValue(`account.accountHolder.${field.name}`, e.target.value.replace(/[()+,' '-]/g, '').trim())}
						onBlur={handleBlur}
						disabled={editMode}
						className={get(errors, `account.accountHolder.${field.name}`) && get(touched, `account.accountHolder.${field.name}`) ? 'form-control is-invalid' : 'form-control'}
					/>
					{get(errors, `account.accountHolder.${field.name}`) && get(touched, `account.accountHolder.${field.name}`) && <div className="invalid-feedback">{get(errors, `account.accountHolder.${field.name}`)}</div>}
				</div>
			);
		} else if (field.name === 'dateOfBirth') {
			return (
				<div className="form-group" key={field.index}>
					<label style={{ display: 'block', marginBottom: '5px' }}>
						{this.state.fieldLabels[field.name] + ' ' + optional}
					</label>
					<DatePicker
						selected={
							values.account.accountHolder[field.name]
								? new Date(values.account.accountHolder[field.name])
								: null
						}
						name={`account.accountHolder.${field.name}`}
						onChange={(date) => {

							setFieldValue(`account.accountHolder.${field.name}`, date ? date.toISOString() : null);
						}}
						onBlur={handleBlur}
						disabled={editMode}
						className={
							get(errors, `account.accountHolder.${field.name}`) &&
							get(touched, `account.accountHolder.${field.name}`)
								? 'form-control is-invalid d-block'
								: 'form-control d-block'
						}
						dateFormat="MM-dd-yyyy"
						placeholderText="MM-DD-YYYY"
						wrapperClassName="date-picker-customerinfo"
						showMonthDropdown
						showYearDropdown
						yearDropdownItemNumber={75}
						scrollableYearDropdown
						maxDate={new Date()}
					/>
					{get(errors, `account.accountHolder.${field.name}`) &&
						get(touched, `account.accountHolder.${field.name}`) && (
							<div className="invalid-feedback">
								{get(errors, `account.accountHolder.${field.name}`)}
							</div>
						)}
				</div>
			);
		} else if (field.name === 'mobileNumber' || field.name === 'businessNumber') {
			return (
				<NumberFormatInput
					key={field.index}
					type="text"
					label={this.state.fieldLabels[field.name] + ' ' + optional}
					name={`account.accountHolder.${field.name}.number`}
					size=""
					errors={errors}
					value={values.account.accountHolder[field.name]?.number || ''}
					touched={touched}
					onChange={(e) =>
						setFieldValue(
							`account.accountHolder.${field.name}.number`,
							e.target.value.replace(/[()+,' '-]/g, '').trim()
						)}
					onBlur={handleBlur}
					isDisabled={editMode}
				/>
			);
		} else if (field.name.toUpperCase().includes('EMAIL')) {
			let confirmEmailValue;
			let confirmEmailName;

			if (field.name.toUpperCase() === "PERSONALEMAIL") {
				confirmEmailValue = values.account.accountHolder.confirmEmail;
				confirmEmailName = `account.accountHolder.confirmEmail`;
			} else {
				confirmEmailValue = values.account.accountHolder.confirmBusinessEmail;
				confirmEmailName = `account.accountHolder.confirmBusinessEmail`;
			}

			return (
				<>
					<GuestOrderInput
						key={field.index}
						type="text"
						label={this.state.fieldLabels[field.name] + ' ' + optional}
						name={`account.accountHolder.${field.name}`}
						size=""
						errors={errors}
						value={values.account.accountHolder[field.name] || ''}
						touched={touched}
						onChange={handleChange}
						onBlur={handleBlur}
						isDisabled={editMode}
					/>
					<GuestOrderInput
						key={field.index + 1}
						type="text"
						label={`Confirm ` + this.state.fieldLabels[field.name] + ' ' + optional}
						name={confirmEmailName}
						size=""
						errors={errors}
						value={confirmEmailValue || ''}
						touched={touched}
						onChange={handleChange}
						onBlur={handleBlur}
						isDisabled={editMode}
					/>
				</>
			);
		} else {
			return (
				<GuestOrderInput
					key={field.index}
					type="text"
					label={this.state.fieldLabels[field.name] + ' ' + optional}
					name={`account.accountHolder.${field.name}`}
					size=""
					errors={errors}
					value={values.account.accountHolder[field.name] || ''}
					touched={touched}
					onChange={(e) => { setFieldValue(`account.accountHolder.${field.name}`, e.target.value.replace(/[^a-z\-A-Z\s']/g, '').trimStart()) }}
					onBlur={handleBlur}
					isDisabled={editMode}
				/>
			);
		}
	}


	clearSalesAgentSuggestions = () => {
		this.setState({
			salesAgentSuggestions: []
		});
	};

	render() {
		const {
			values,
			errors,
			touched,
			handleChange,
			handleBlur,
			setFieldValue,
			createAccountAndOrderLoader,
			createAccountAndOrderError,
			handleChangeStep,
			newAccountInfoData
		} = this.props;

		const editMode = !isEmpty(newAccountInfoData);

		return (
			<div className="form-section" id="fs5">

				<h4>{this.state.title}</h4>
				<p><i className="fas fa-map-marker-alt" /> {values.formattedAddress}</p>
				<p className="text-center text-xs text-muted d-block d-sm-none">Scroll down to see map</p>


				{this.props.fields.length && this.props.fields.map((field, index) => (
					this.dynamicallyRenderFormFields(field)
				))
				}

				{!editMode && (
					<Fragment>
						<p className="text-xs">{this.state.termsAndCondition}</p>
						<div className="form-group custom-checkbox">
							<input
								type="checkbox"
								className="custom-control-input"
								id="agree-tc"
								name="account.termsAndCondition"
								checked={editMode? true: values.account.termsAndCondition}
								onChange={(e) => setFieldValue('account.termsAndCondition', e.target.checked)}
								onBlur={handleBlur}
								disabled={editMode}
							/>
							<label className="custom-control-label" htmlFor="agree-tc">
								{ReactHtmlParser(
									this.state.termsAndConditionsLink
								)}
							</label>
							{get(errors, `account.termsAndCondition`) &&
								get(touched, `account.termsAndCondition`) && (
									<div style={{display: 'block'}} className="invalid-feedback">
										{get(errors, `account.termsAndCondition`)}
									</div>
								)}
						</div>
					</Fragment>
				)}

				{createAccountAndOrderError && <p style={{ color: 'red' }}>{createAccountAndOrderError}</p>}

				<div className="form-group form-group-footer">
					<button
						onClick={() => handleChangeStep(editMode? 'confirmation': 'packages-and-products')}
						type="button"
						id=""
						className="btn btn-quick"
						data-target="fs5"
					>
						Back
					</button>
					<button
						disabled={createAccountAndOrderLoader || !isEmpty(errors) || this.props.formSubmitting}
						type="submit"
						id=""
						className="btn btn-primary"
						data-target="fs7"
					>
						Submit {createAccountAndOrderLoader && <i className="fas fa-fw fa-spin fa-spinner" />}
					</button>
				</div>

			</div>
		);
	}
}

const salesAgentsLoader = createLoadingSelector(['GET_SALES_AGENTS']);

const mapStateToProps = (state) => ({
	salesAgentsLoading: salesAgentsLoader(state),
	suffixOptions: selectSuffixOptions(state)
});

const mapDispatchToProps = {
	searchSalesAgents,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CustomerInfoStep);
